module.exports = __webpack_public_path__ + "static/media/backrest.47fea978.svg";